import { render, staticRenderFns } from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=template&id=3fa6963e&scoped=true"
import script from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
export * from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
import style0 from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=style&index=0&id=3fa6963e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6963e",
  null
  
)

export default component.exports